export default {
  email (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (!new RegExp('^[a-z0-9_+\\.-]+\\@([a-z0-9-]+\\.)+[a-z0-9]{2,4}$').test(value)) {
        callback(new Error('请输入正确的邮箱地址'))
      }
    }
    callback()
  },
  mobilePhone (rule, value, callback) {
    if (value !== undefined && value !== null && value !== '') {
      if (!new RegExp('^1[3456789]\\d{9}$').test(value)) {
        callback(new Error('请输入正确的手机号码'))
      }
    }
    callback()
  }
}
